import { ISessionData } from "../../app/store/sessionData/types";
import User from "../sessionData/User";
import FlashMessage from "../sessionData/FlashMessage";
import Gtm from "./Gtm";

export default class SessionData implements ISessionData {

  user: User;
  flashMessages: FlashMessage[];
  captchaRequired: boolean;
  gtmData: Gtm;
  numberOfOrderItems: number;
  redirectUser: boolean;

  constructor(user: User, flashMessages: FlashMessage[], captchaRequired:boolean, gtm: Gtm, numberOfOrderItems: number, redirectUser: boolean) {
    this.user = user;
    this.flashMessages = flashMessages;
    this.captchaRequired = captchaRequired;
    this.gtmData = gtm;
    this.numberOfOrderItems = numberOfOrderItems;
    this.redirectUser = redirectUser;
  }

}
